import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/Onboarding/SldeMessage/';

export const ONBOARDING_SLIDE_MESSAGE_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const ONBOARDING_SLIDE_MESSAGE_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;
